module.exports = __webpack_public_path__ + "img/inco1Ac.8087e9ce.png";